import {memo} from "react";
import {Link} from "react-router-dom";
import {numberFormat} from "~/utils";
import FontAwesomeIcon from "~/components/FontAwesome";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Thu chờ xác định cho Dashboard Kế toán trưởng.
 * Dữ liệu: dashboardApi.accountingPendingReceipt() = { pending, count }.
 */
function AccountingPendingWidget({data, loading = false}) {

	const pending = data?.pending || 0;
	const count   = data?.count || 0;

	const link = (
		<Link to="/pending-receipt" style={{color: '#fff', fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4}}>
			Xử lý <FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square" />
		</Link>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(219,39,119,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon="fa-light fa-circle-question"
				title="Thu chờ xác định"
				gradient="linear-gradient(135deg, #9d174d 0%, #db2777 60%, #f472b6 100%)"
				badge={count ? `${count} khoản` : null}
				extra={link}
			/>
			<div style={{padding: '16px 18px'}}>
				{loading
					? <div style={{textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '8px 0'}}>Đang tải...</div>
					: (
						<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
							<div>
								<p style={{fontSize: 12, color: '#64748b', margin: 0}}>Tổng tiền chưa rõ nguồn</p>
								<p style={{fontSize: 22, fontWeight: 700, color: pending > 0 ? '#db2777' : '#94a3b8', margin: '2px 0 0'}}>
									{numberFormat(pending)}
								</p>
							</div>
							<FontAwesomeIcon
								icon="fa-light fa-hand-holding-dollar"
								style={{fontSize: 34, color: pending > 0 ? '#f9a8d4' : '#e2e8f0'}}
							/>
						</div>
					)
				}
			</div>
		</div>
	);
}

export default memo(AccountingPendingWidget);
